<offconon-shared-ui-virtualscroll-dropdown
  [selectOptions]="languageList() || []"
  [selectedOption]="selectedLanguage()"
  [pageSize]="45"
  [page]="languageResponse()?.current_page_number || 1"
  (selectedOptionOutput)="select($event)"
  (paginationOutput)="onPagination($event)"
  (searchOutput)="onSearch($event)" />
